import { client } from './request.js';
export async function getUserByEmail(params) {
    const searchParams = new URLSearchParams({ ...params });
    return client.get('api/user', { searchParams }).json();
}
